<template>
    <div>
        <CustomMarkdownEditor />
    </div>
</template>

<script>
import CustomMarkdownEditor from '@/components/customComponents/CustomMarkdownEditor';
export default {
    name: 'Test',
    components: {
        CustomMarkdownEditor
    }
}
</script>

<style lang="scss" scoped>

</style>